import React from 'react';
import { useAuth } from '@/context';
import OwnerDashboard from './OwnerDashboard';
import AdminDashboard from './AdminDashboard';
import TeacherDashboard from './TeacherDashboard';
import OfficeDashboard from './OfficeDashboard';
import StudentDashboard from './StudentDashboard';
import { Dashboard } from './Dashboard';

const RoleBasedDashboard: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: '#D4AF37'
      }}>
        Loading...
      </div>
    );
  }

  // Render dashboard based on role + (for `staff`) staff_type. Prompt
  // 11E.8: a `staff` caller lands on the wrong dashboard variant if this
  // switch ignores staff_type — the exact staff_type/scoping mismatch the
  // 11E.5 review flagged (an Office Manager landing on the teacher page
  // and seeing no data). `office_manager` -> OfficeDashboard; every other
  // staff_type (`teacher`, `other`, or unset) -> TeacherDashboard.
  switch (user?.role) {
    case 'owner':
      return <OwnerDashboard />;
    case 'admin':
    case 'manager':
      return <AdminDashboard />;
    case 'staff':
      return user.staff_type === 'office_manager' ? <OfficeDashboard /> : <TeacherDashboard />;
    case 'viewer':
      return <StudentDashboard />;
    default:
      return <Dashboard />;
  }
};

export default RoleBasedDashboard;
